import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ApiButton,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from 'web-library';
import { useDeleteSpecialConsiderationSubject } from '../../../api-refactored/special-consideration/useDeleteSpecialConsiderationSubject';

const useStyles = makeStyles()((theme) =>
({
  radioButton: {
    padding: '0px',
    margin: '0px',
  },
  backButton: {
    marginRight: theme.spacing(2),
  },
  buttonContainer: {
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  addIcon: {
    verticalAlign: 'sub',
    marginRight: 10,
    color: theme.color.icon.iconInverse,
  },
  selectSubjectText: {
    marginTop: theme.spacing(3),
  },
  customSelect: {
    marginTop: theme.spacing(2),
  },
  divider: {
    marginTop: theme.spacing(5),
  },
}));

interface AddSubjectModalProps {
  modalState: boolean;
  onDialogClose: () => void;
  requestUuid: string;
  detailUuid: string;
  subjectName: string;
  refetch: () => void;
  setSubjectError?: (value: string | null) => void;
}

const DeleteSubjectModal = ({
  modalState,
  onDialogClose,
  requestUuid,
  detailUuid,
  subjectName,
  refetch,
  setSubjectError,
}: AddSubjectModalProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  const deleteSubjectRequest = useDeleteSpecialConsiderationSubject({
    onSuccess: () => {
      setSubjectError?.(null);
      onDialogClose();
      refetch();
    },
  });

  const handleDelete = () => {
    deleteSubjectRequest.mutate({ requestUuid, detailUuid });
  };

  return (
    <Dialog open={modalState} maxWidth="md" onClose={onDialogClose}>
      <DialogTitle>
        <Typography variant="h4">
          {t('specialConsideration->>ApplyForSpecialConsideration.DeleteSubjectPaper')}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {`${t('specialConsideration->>Dialog.You are about to delete')} ${subjectName}. ${t(
            'specialConsideration->>Dialog.Are you sure want to proceed'
          )}`}
        </DialogContentText>
      </DialogContent>
      <DialogActions id="opsadmin-dialog-action">
        <Box className={classes.buttonContainer}>
          <Button onClick={onDialogClose} variant="text">
            {t('specialConsideration->>Dialog.Cancel')}
          </Button>
          <ApiButton status={deleteSubjectRequest.status} type="button" onClick={handleDelete}>
            {t('specialConsideration->>SelectExamLevelModal.Proceed')}
          </ApiButton>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteSubjectModal;
